/**
 * The ADM Panel prefix is a cross-repo contract, not a local choice: the menu entries come from
 * Strapi content, and the host only ever sees whatever `url` those records carry. It lives here as
 * one constant so a change to that contract costs one line instead of a hunt across the host.
 *
 * English kebab-case, matching every other host route (`/my-tasks`, `/ges/about-sodexo`,
 * `/workforce-sizing`). The keys carry the same words as the values so this file cannot drift into
 * reading `acessos: 'access'`.
 */
export const ADM_PANEL_BASE_PATH = '/admin-panel';

export const ADM_PANEL_ROUTE_PATTERN = `${ADM_PANEL_BASE_PATH}/*`;

export const ADM_PANEL_AREA_PATHS = {
  access: `${ADM_PANEL_BASE_PATH}/access`,
  history: `${ADM_PANEL_BASE_PATH}/history`,
  settings: `${ADM_PANEL_BASE_PATH}/settings`,
} as const;
